module.exports = __webpack_public_path__ + "9e8840fea26ba120409b906e29d89732.pdf";